/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import colors from "../../base/colors";

const { dark } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      color: "primary.contrastText",
      top: "-9px !important",

      // The -9px nudge above is only meant for the resting (unshrunk)
      // label position of Soft UI's own inputs. MUI's floating labels
      // (e.g. the DatePicker "From"/"To" fields) already translate
      // themselves up by 9px when shrunk — stacking this override on
      // top of that pushed shrunk labels an extra 9px above their own
      // field, into whatever sits above it (another field's label/text).
      "&.MuiInputLabel-shrink": {
        top: "0 !important",
      },
    },
  },
};

export default formLabel;
